import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading03, typeHeading04, typeBody03, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery } from '../../theme/metrics'
import { WHITE_01, BLUE_01 } from '../../theme/colors'

import { StyledButtons } from '../../theme/components'

import { button } from '../../theme/core';

export const Inner = styled.div`
	${row({medium:true})}
`

export const HeadingContainer = styled.div`
	${props => column({medium:{span:5,after:1},large:{span:3,after:1}},{direction:props.theme.direction})}
`

export const QuestionsContainer = styled.div`
	${props => column({medium:{span:6},large:{span:8}},{direction:props.theme.direction})}
	margin-bottom: ${unit(-3)};

	${mediaQuery[SIZE.large]}{
		margin-bottom: ${spacer(-1)};
	}
`

export const Heading = styled.div`
	${typeHeading02}
	color: ${props => props.theme.foreground};
	padding-bottom: ${spacer(1)};
	
	${mediaQuery[SIZE.large]}{
		padding-bottom: 0;
	}
`

export const QuestionList = styled.ul`
	${row({medium:true})}
`

export const Question = styled.div`
	${typeHeading04}
	color: ${props => props.theme.alternative};
	display: flex;
	justify-content: space-between;
	cursor: pointer;

	${mediaQuery[SIZE.large]}{
		cursor: auto;
	}
`

export const Answer = styled.div`
	${typeBody03}
	margin-top: ${unit(2)};
	color: ${props => props.theme.foreground};

	${mediaQuery[SIZE.large]}{
		margin-top: ${unit(3)};
	}
	
`

export const ExpandArrow = styled.svg`
	fill: ${BLUE_01};
	margin-left: ${unit(3)};
	margin-top: 12px;
	flex: 0 0 11px;

	${mediaQuery[SIZE.large]}{
		display: none;
	}
`

export const QuestionContainer = styled.li`
	${props => column({medium:{span:6,total:6},large:{span:4,total:8}},{direction:props.theme.direction})}
	margin-bottom: ${unit(3)};

	${mediaQuery[SIZE.large]}{
		margin-bottom: ${spacer(1)};
	}

	${Answer}{
		display: ${props => props.active ? `block` : `none`};

		${mediaQuery[SIZE.large]}{
			display: block;
		}
	}
`



